<script lang="ts">
    import type {Document, DocumentAvailability} from 'src/typings';
    import {getInjector, getLocalization} from 'src/core';
    import {onMount} from 'svelte';
    import {KpSearchItemDocumentPresenter} from '../../search/kp-resolvable-search-results-displayer/kp-search-item-document/kp-search-item-document.presenter';
    import Labels from 'shared/components/kp-label/Labels.svelte';
    import KpCover from '../kp-cover/KpCover.svelte';

    export let record: Document;

    const localize = getLocalization();
    const presenter = getInjector().getByClass(KpSearchItemDocumentPresenter);

    $: documentLink = `records/${record.id}`;
    let availability: DocumentAvailability;

    let coverImageWidth = 0;
    let coverImageHeight = 0;

    onMount(async () => {
        availability = await presenter.getAvailability(record);
    });
</script>

<div class="kp-record-tile">
    {#if !record.external}
        <div class="cover-container cover-container-document-search-simplified"
             bind:clientWidth={coverImageWidth}
             bind:clientHeight={coverImageHeight}>

            <KpCover record={record} href={documentLink} fillTo='width'/>
        </div>
    {/if}

    <h2 class="unset-style record-name">
        {#if record.external}
            <span>{record.name}</span>
        {:else}
            <a href={documentLink}>{record.name}</a>
        {/if}
    </h2>

    {#if record.primaryAuthors && record.primaryAuthors.length > 0}
        <div class="document-author">
            <Labels labeleds={record.primaryAuthors}/>
        </div>
    {/if}

    {#if availability?.freeItemsCount < 1}
        <!-- Turned off in styles by default (display: none), used in the art library (artoteka.moravska-galerie.cz)-->
        <!-- Turned on and styled in custom styles (nalepka-vypujceno.css) -->
        <div class="document-unavailable-badge"
             style:--cover-width="{coverImageWidth}px"
             style:--cover-height="{coverImageHeight}px">

            {localize(/* @kp-localization loan.Borrowed */ 'loan.Borrowed')}
        </div>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "bootstrap-less/bootstrap/variables";

    .kp-record-tile {
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;

        .cover-container {
            margin-bottom: @spacing-m;
        }

        .record-name {
            margin-left: 1px;
            margin-bottom: @spacing-xs;
            font-size: 16px;

            a {
                color: inherit;
            }
        }

        .document-author {
            margin-left: 1px;
        }
    }

    .document-unavailable-badge {
        pointer-events: none;
        position: absolute;
        right: 10px;
        top: var(--cover-height);
        transform: translateY(-100%);
    }

    :global {
        .kp-record-tile {
            .cover-container .obalImg {
                border-radius: @border-radius-default;
            }

            .document-author a {
                color: #777;
            }
        }
    }

    // Used in Artoteka (artoteka.moravska-galerie.cz), turned on and styled in custom styles (nalepka-vypujceno.css)
    :global(.document-unavailable-badge) {
        display: none;
    }
</style>